<template>
  <modal :value="value"
         max-width="500"
         content-class="sms-plan-add-form modal-device"
         :has-padding="false"
         @input="emitInput">

    <div class="sms-plan-add-form-body">
      <form @submit.prevent="onSubmit">
        <div class="sms-plan-add-form-body-header">
          <button v-if="!isEdit"
                  type="button"
                  @click="emitBack">
            <i class="mdi mdi-arrow-left pointer"></i>
          </button>
          <h1>{{ modalTitle }}</h1>
        </div>

        <div class="sms-plan-add-form-body-inputs">
          <v-text-field v-model="form.name"
                        :name="$t('message.generics.message.name')"
                        :label="$t('message.generics.message.name')"
                        v-validate="'required'"
                        :error-messages="errors.collect($t('message.generics.message.name'))"></v-text-field>

          <v-text-field v-model="form.smsAmount"
                        v-validate="'required'"
                        type="number"
                        :label="$t('message.marketingPlan.message.smsAmount')"
                        :name="$t('message.marketingPlan.message.smsAmount')"
                        :error-messages="errors.collect($t('message.marketingPlan.message.smsAmount'))"></v-text-field>

          <v-text-field v-model="form.emailAmount"
                        v-validate="'required'"
                        type="number"
                        :label="$t('message.marketingPlan.message.emailAmount')"
                        :name="$t('message.marketingPlan.message.emailAmount')"
                        :error-messages="errors.collect($t('message.marketingPlan.message.emailAmount'))"></v-text-field>

          <!-- <v-text-field v-model="form.whatsappAmount"
                        v-validate="'required'"
                        type="number"
                        :label="$t('message.marketingPlan.message.whatsAppAmount')" 
                        :name="$t('message.marketingPlan.message.whatsAppAmount')"
                        :error-messages="errors.collect($t('message.marketingPlan.message.whatsAppAmount'))"></v-text-field> -->
        </div>

        <v-card-actions class="sms-plan-add-form-body-actions">
          <button class="btn btn-extra-round btn-primary">
            {{ actionLabel }}
          </button>
        </v-card-actions>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      page: 0,
      possiblePlans: [],
      form: {
        name: undefined,
        smsAmount: undefined,
        emailAmount: undefined,
        whatsappAmount: undefined,
      },
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
  },

  watch: {
    value(val) {
      if (val) {
        if (this.isEdit) {
          this.setInitialEditData();
        } else {
          this.resetInitialData();
        }
      }
    },
  },

  computed: {
    isEdit() {
      return !!this.item;
    },
    modalTitle() {
      return this.isEdit
        ? this.$t("message.marketingPlan.message.editPlan")
        : this.$t("message.marketingPlan.message.addPlan");
    },
    actionLabel() {
      return this.isEdit
        ? this.$t("message.generics.message.edit")
        : this.$t("message.generics.message.add");
    },
  },

  mounted() {
    if (this.isEdit) {
      this.setInitialEditData();
    }
  },

  methods: {
    resetInitialData() {
      this.form = {
        name: undefined,
        smsAmount: undefined,
        emailAmount: undefined,
        // whatsappAmount: undefined,
      };
    },
    setInitialEditData() {
      this.form = {
        name: this.item.name,
        smsAmount: this.item.smsAmount,
        emailAmount: this.item.emailAmount,
        // whatsappAmount: this.item.whatsappAmount,
      };
    },
    emitBack() {
      this.$emit("back");
    },
    emitInput(value) {
      this.$emit("input", value);
    },
    hideModal() {
      this.emitInput(false);
    },
    onSubmit() {
      if (this.isEdit) {
        this.editPlan();
      } else {
        this.addPlan();
      }
    },
    async addPlan() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        await this.$api.marketing.plan.create({
          name: this.form.name,
          smsAmount: Number(this.form.smsAmount),
          emailAmount: Number(this.form.emailAmount),
          // whatsappAmount: Number(this.form.whatsappAmount),
        });

        this.$emit("added");
      }
    },
    async editPlan() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        await this.$api.marketing.plan.edit({
          planId: this.item.id,
          name: this.form.name,
          smsAmount: Number(this.form.smsAmount),
          emailAmount: Number(this.form.emailAmount),
          // whatsappAmount: Number(this.form.whatsappAmount),
        });

        this.$emit("edited");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-plan-add-form {
  .sms-plan-add-form-body {
    padding: 10px 20px;

    .sms-plan-add-form-body-header {
      position: relative;

      h1 {
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 40px;
      }

      button {
        position: absolute;
        font-size: 30px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .sms-plan-add-form-body-inputs {
      width: 60%;
      margin: 0 auto 30px;
    }

    .sms-plan-add-form-body-actions {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
